const Joi = require('@hapi/joi')
const { uuid } = require('../../fields')

const schema = Joi.object({
  doctorId: uuid.required(),
  doctorPatientTestId: uuid.required(),
  note: Joi.string().required(),
})

module.exports = schema
